import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-footer',
	template: `
		<div class="app-footer">
			<a href="https://www.spydertech.net.au" target="_blank" class="app-logo-img">
				<img alt="Spydertech logo lightmode" src="images/spydertechlogo-footer-light.svg" class="is-light" />
				<img alt="Spydertech logo darkmode" src="images/spydertechlogo-footer-dark.svg" class="is-dark" />
			</a>
			<small>
				All Rights Reserved
				@if (version) {
					(v{{ version }})
				}
			</small>
		</div>
	`,
	standalone: false,
})
export class FooterComponent {
	version = environment.appVersion;
}
